export default __webpack_public_path__ + "static/media/quiz.c2d44f90.png";